import { defaultOptions } from "../global/slick-options";
import { getAll } from "../utilities/querySelector";

const accreditationsSlider = getAll('[data-slider="accreditations-slider"]');

let options = {
    ...defaultOptions,
};

if (accreditationsSlider.length) {
    accreditationsSlider.forEach((slider) => {
        options = {
            ...defaultOptions,
            slidesToShow: 4,
            arrows: false,
            infinite: true,
            centerMode: true,
            centerPadding: "0",
            responsive: [
                {
                    breakpoint: 767,
                    settings: "unslick",
                },
                {
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 3,
                    },
                },
            ],
        };

        jQuery(slider).slick({
            ...options,
        });

        window.addEventListener("resize", () => {
            if (
                window.innerWidth > 767 &&
                !jQuery(slider).hasClass("slick-initialized")
            ) {
                jQuery(slider).slick({
                    ...options,
                });
            }
        });
    });
}
